import React,{useState,useEffect,useCallback} from 'react';
import { useHistory,useParams,useLocation} from "react-router-dom";
import axios from "../../utils/axios";
import Swal from 'sweetalert2'
import { getToken } from '../../utils/Common';
import HEAD from '../../component/header'
import SIDE from '../../component/navbar'
import DataTable from 'react-data-table-component';
import Moment from 'moment';

function PurchaseOrder() {

const token = getToken();
const headers = { Authorization: `Bearer ${token}`,'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' };
const history = useHistory();
const FileDownload = require('js-file-download');  
// Session
const session = localStorage.getItem('user');
const udeptID = JSON.parse(session).dept_id;
const hcode = JSON.parse(session).hotel_id;

// Var
const [PurchaseOrder, setPurchaseOrder] = useState([]);
const [hotelList, setHotelList] = useState([]);

const getListHotelbyUser = useCallback (() => {
  axios
  .post(`/api/list/hotel/by-user`,{hcode},{headers:headers})
  .then(function (response) {
      setHotelList(response.data)
  })
  .catch(function (error) {
      console.log("Error API Hotel: ", error);
  });
},[hcode,headers]);

const getListPO = (hotel) => {

  if(hotel){
    const hcode = hotel;
    axios.post('/api/waiting/purchase/order',{hcode,udeptID},{headers:headers})
      .then(function (response) {
          // console.log(response.data);
          setPurchaseOrder(Object.values(response.data).flatMap(arr => arr))
      })
      .catch(function (error) { 
        console.log(error)
    });
  }
  else
  {
      axios.post('/api/waiting/purchase/order',{hcode,udeptID},{headers:headers})
        .then(function (response) {
            // console.log(response.data);
            setPurchaseOrder(Object.values(response.data).flatMap(arr => arr))
        })
        .catch(function (error) { 
          console.log(error)
      });
  }   

}

const downloadPurchaseorder = () => {
  axios
  .get(`/api/generate/excel/report/purchase/order/${hcode}`,
    {responseType: 'blob'},
    {headers:headers}
  )
  .then(function (response) {
    // console.log(response.data);
    FileDownload(response.data, 'purchase_order.xlsx');
  })
  .catch(function (error) {
      console.log(error)
  });
}

 // Search 
 const [filtertext, setFilterText] = useState('');
 const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

 const filteredItems = PurchaseOrder.filter(
     search => (Object.values(search).join('').toLowerCase().includes(filtertext.toLowerCase()))
 );

 const handleClear = () => {
     if (filtertext) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
     }
 };

const columns = [
  
  {
    name: ' No.',
    width: '200px',
    cell: (row) => (
      <div>
      <b>PO No: </b> {row.id_po}
      <br />
      <b>PR No</b> : {row.nomer}
      </div>
  ),
   
    // selector: row => row.nomer,
  },
  {
      name: 'Item',
      wrap:true,
      cell: (row) => (
          <div style={{paddingTop:"10px",paddingBottom:"10px",color:"#580C30"}}>
          {row.nama_item}
          </div>
      ),
  },
  {
    name: 'Origin',
    wrap:true,
    cell: (row) => (
        <div>
        <b>For Hotel</b> : {row.nm_hotel}
        <br />
        <b>From Department: </b> {row.nm_department}
        </div>
    ),
  },
{
  name: 'Supplier.',
  wrap: true,
  selector: row => row.companyname,
},
{
  name: 'Need',
  cell: (row) => Moment(row.date_need).format('LLL'),
},
{
  name: 'PO Created',
  cell: (row) => Moment(row.created_at).format('LLL'),
},
{
  name: 'PO Sent',
  wrap:true,
  cell: (row) => Moment(row.posent).format('LLL'),
},
{
  name: 'PO File',
    cell: (row) => (
      <div>
        {row.file_po &&
          <button className='btn btn-success' onClick={()=> window.open(row.file_po, "_blank")}><i className="bi bi-file-earmark-pdf-fill"></i></button>
        }
      </div>
  ),
},
{
    name: '',
    width: '50px',
    cell: (row) => (
      <>
      <div style={{marginRight:"10px"}} onClick={()=>history.push(`/detail/proposal/${row.id_pp}`)}>
          <i className="bi bi-search"></i>
      </div>
      <div onClick={()=>alert(`Reject PO`)}>
          <i className="bi bi-trash"></i>
      </div>
      </>
    ),
},
  
];

useEffect(() => {
  getListPO(); 
  getListHotelbyUser();
}, []);

  return (
   <>
   <HEAD />
   <SIDE />

   <main id="main" className="main">

    <div className="pagetitle">
      <h1>Purchase Order</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">Purchase Order</li>
          <li className="breadcrumb-item active">List</li>
        </ol>
      </nav>
    </div>

    <section>

      <div className='row'>
        <div className='col-12'> 
          <div className="card">
            <div className="card-body"> 
              <div className="card-title">
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>getListPO()}><i className="bi bi-arrow-clockwise"></i></button>
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>downloadPurchaseorder()}><i className="bi bi-printer"></i></button>
              </div>
              <div className='row mt-4'>
              <div className="col-8">
                <input type="text" className="form-control" placeholder="Search" onChange={e => setFilterText(e.target.value)} onClear={()=>handleClear} filtertext={filtertext}/>
              </div>

              <div className="col-4">
                <select id="hotelSelect" className="form-select" onChange={(e)=>getListPO(e.target.value)}>
                    <option>Group By Hotel</option>
                    {hotelList.map((x, t) => (
                        x.map((v, k) => (
                            <option key={k} value={v.id_hotel}>
                                {v.code_hotel} - {v.nm_hotel}
                            </option>
                        ))
                    ))}  
                    </select>
                </div>

              </div>
             
              <div className='row'>
              <DataTable
                  columns={columns}
                  data={filteredItems}
                  fixedHeader
                  fixedHeaderScrollHeight="440px"
                  pagination
                />
              </div>
               
              
            </div>
          </div>
        </div>
      </div>

    </section>

    </main>
   
   </>
  )
}

export default PurchaseOrder